import UserManagement from './UserManagement';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';

// The main User Management page. All orchestration lives in the shared
// <UserManagement /> component, which the sub-account User Management drawer
// also renders (scoped to a sub-account via its `bearer`). Here we render it
// with no bearer, so it targets the logged-in account.
export default function UserManagementPage() {
  const { t } = useTranslation('translations', { keyPrefix: 'Users.UsersList' });

  return (
    <div>
      <Title> {t('title', { defaultValue: 'User Management' })}</Title>
      <UserManagement />
    </div>
  );
}
